import { ApolloError, gql, TypedDocumentNode, useQuery } from '@apollo/client';
import {
  Interval,
  Resolution,
  SpotPriceForecast,
  SpotPricesQuery,
  SpotPricesQueryVariables,
} from '../../generated/graphql';

const FIFTEEN_MINUTES_MILLISECONDS = 15 * 60 * 1000;

export type { SpotPriceForecast, SpotPriceForecastSlice } from '../../generated/graphql';

export const spotPricesQuery: TypedDocumentNode<SpotPricesQuery, SpotPricesQueryVariables> = gql`
  query SpotPrices($resolution: Resolution!, $from: DateTime!, $to: DateTime!) {
    spotPrices(resolution: $resolution, from: $from, to: $to) {
      lastUpdated
      latestHistoricalSpotPrice
      resolution
      dayAheadForecasts {
        date
        price
      }
      intradayForecasts {
        date
        price
      }
      monthlyMarketValues {
        year
        month
        min
        max
        mean
        isProvisional
      }
    }
  }
`;

export interface SpotPriceOptions {
  resolution?: Resolution;
  interval: Interval;
}

export const useSpotPrices = (
  options: SpotPriceOptions,
): { data: SpotPriceForecast | undefined; loading: boolean; error?: ApolloError } => {
  const { data, loading, error } = useQuery(spotPricesQuery, {
    variables: {
      resolution: options.resolution ?? Resolution.ONE_HOUR,
      from: options.interval.start,
      to: options.interval.end,
    },
    pollInterval: FIFTEEN_MINUTES_MILLISECONDS,
    errorPolicy: 'all',
  });

  return { data: data?.spotPrices, loading, error };
};
